import { useFormsStore } from 'vuniform';
import seedrandom from 'seedrandom';

const rngSeedBase = new Date().getTime();

export const formIds = (keyFn: (k: unknown) => string): string[] => {
  const idGenerator = seedrandom(`${rngSeedBase}-${keyFn('')}`);
  const formsStore = useFormsStore();
  const ids = [];

  let currentId = keyFn(idGenerator.int32());
  for (let nextId = keyFn(idGenerator.int32()); ; currentId = nextId, nextId = keyFn(idGenerator.int32())) {
    const form = formsStore.forms[currentId];
    ids.push(currentId);
    if (!form) {
      break;
    }

    const row: { [k: string]: unknown } = formsStore.formGetValues(currentId);

    if (!Object.keys(row).some((k: string) => row[k])) {
      if (!formsStore.forms[nextId]) {
        break;
      }
    }
  }

  return ids;
};
